/**
 * Use Debounce Hook Export
 *
 * @since 1.0.0
 */

export { useDebounce } from './hook';
export type { UseDebounceParams, UseDebounceReturn } from './types';

